<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container-fluid">
					<a class="navbar-brand cursor" @click="getPath()">
						<img src="../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0" v-if="shouldShowLoginBtn">
						<button class="btn btn-light btn-sm my-2 my-sm-0" @click="gotoLogin()">
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<div class="flex-shrink-0 d-flex flex-column bg-grey200">
			<section class="inner container py-5 ">
				<div class="center-contain pt-5 text-center">
					<h1 class="pricing-heading">Flexible Plans & Pricing</h1>
					<p class="label-text my-4">Choose payment plan suitable for you</p>
				</div>
				<!-- v-if="this.packages.length<1" -->
				<!-- <p class="lead my-5" >
					Select Package
					<select
						class="form-control select-lg ml-3"
						id="exampleFormControlSelect1"
						v-model="currentPackage"
					>
						<option
							:value="item.id"
							v-for="(item, index) in packages"
							:key="index"
							>{{ item.title }}</option
						>
					</select>
				</p> -->
			</section>
			<section class="price-data pb-0">
				<div class="container">
					<div class="card-deck">
						<div class="card" v-for="(card, index) in currentSubsList" :key="index">
							<div class="card-body">
								<p class="mb-4">{{ card.title }}</p>
								<p>
									<small>{{ card.currency }}</small>
								</p>
								<h1 class="mb-5">{{ card.price }}</h1>
								<a :href="getpaymentHref(card)" class="btn btn-outline-light mb-4">SELECT PLAN</a>
								<ul>
									<li v-for="(planDetails, index) in getPlanDetails(card)" :key="index"
										:class="{ 'gray-text': isNotAvailabele(card, planDetails) }"
										v-if="showPlanDeatils(card, planDetails)">
										{{ planDetails }}
									</li>


								</ul>
							</div>
						</div>
					</div>
					<div class="py-5">
						<p class="text-center pt-4 label-text">Download App</p>
						<p class="text-center ">
							<img src="../assets/img/google-play.png" class="cursor" @click="gotoAppStore('google')"
								alt="" />
							<img src="../assets/img/app-store.png" @click="gotoAppStore('apple')" class="cursor ml-2"
								alt="" />
						</p>
					</div>
				</div>
			</section>
		</div>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<style scoped>
.py-5 {
	padding-bottom: 2rem !important;

}

.cursor {
	cursor: pointer;
}

.gray-text {
	color: gray;
}
</style>

<script>
export default {
	name: "Packages",
	components: {},
	metaInfo: {
		title: "CHOOSE YOUR PLAN",
		meta: [
			{
				name: "description",
				content:
					"iBAKATV offers a wide range of subscription plans that are flexible to choose from. You can pause or cancel your subscription anytime.",
			},
		],
	},
	watch: {
		currentPackage: function (val) {
			var currentSubs = this.getSubsById(val);
			this.currentPackage = currentSubs.id;
			this.currentSubsList = currentSubs.subscriptions;
		},
	},
	methods: {

		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},

		gotoLogin() {
			this.$store.commit("logoutUser");
			this.$router.push("/login");
		},
		getpaymentHref(card) {
			// return "/#/selectpayment-dsp/" + card.id + "/" + this.currentPackage;
			// return("/#/selectpayment-nig/" + card.id + "/" + this.currentPackage)
			// if(this.$store.state.globalconfigs.country_code==="ZA"){
			// 	return ("/#/selectpayment-nig/" + card.id + "/" + this.currentPackage);
			// }
			return "/#/selectpayment-dsp/" + card.id + "/" + this.currentPackage;
		},
		getSubsById(pid) {
			var currentPackageObj = this.packages.find((ele) => ele.id == pid);
			return currentPackageObj;
		},
		getPath() {
			if (this.$store.state.user.logedin == true) {
				this.$router.push("/home");
			} else
				// self.commit("setPackageRoute", true);
				this.$router.push("/login");
		},
		getPlanDetails(card) {
			if (card.metaData.plan_details_keys) {
				const planDetails = JSON.parse(card.metaData.plan_details_keys)
				return planDetails
			}
			else {
				return ""
			}
		},
		isNotAvailabele(card, planDetails) {
			if (card.metaData[planDetails] == "false") {
				return true;
			}
			return false;
		},
		showPlanDeatils(card, planDetails) {
			if (card.metaData[planDetails]) {
				return true;
			}
			return false;
		},

	},

	created() {
		this.$store.commit("showPopup", false);
		this.$store.commit("showSpecialPopUp", false);
		this.packages = this.$store.state.packages;
		this.packages = this.packages.filter(item => item.metaData.special_plan != "true");
		this.currentPackage = this.$store.state.packages[0].id;
	},

	data() {
		return {
			currentCard: {},
			packages: null,
			currentPackage: null,
			currentSubsList: null,
		};
	},
	computed: {
		shouldShowLoginBtn() {
			if (this.$store.state.user.logedin == false) {
				return true;
			}
			else {
				return false;
			}
		}

	}
};
</script>
